import { isChinaUser } from '../utils/ChinaUtil';

export const USER_LEVELS = {
    1: {
        start: 0,
        end: 19
    },
    2: {
        start: 20,
        end: 59
    },
    3: {
        start: 60,
        end: 139
    },
    4: {
        start: 140,
        end: 299
    },
    5: {
        start: 300,
        end: 619
    },
    6: {
        start: 620,
        end: 1259
    },
    7: {
        start: 1260,
        end: 2539
    },
    8: {
        start: 2540,
        end: 5099
    },
    9: {
        start: 5100,
        end: 10219
    },
    10: {
        start: 10220,
        end: null // level 10 can extend to any number of points above 300 at this time
    }
    // ...
    // other levels could be added in the future
};

export const DEFAULT_LAT_LON = isChinaUser() ? [39.92889, 116.38833] : [38.854699, -94.797763]; // Beijing or Olathe

export const userGoalType = {
    steps: 'DAILY_SUMMARY',
    activity: 'ACTIVITY',
    weight: 'WEIGHT_GRAMS'
};

export const userGoalCategory = {
    manual: 'MANUAL'
};

export const trackingPeriodType = {
    daily: 'DAILY'
};

export const SegmentActivityTypeIds = {
    any: 0,
    running: 1,
    cycling: 2
};

export const SegmentTypePk = {
    segment: 'classificationPk',
    surface: 'surfaceTypePk',
    activity: 'activityTypePk'
};

export const SegmentsAvailable = {
    CREATED_BY_ME: 'CREATED_BY_ME',
    RECENTLY_COMPLETED: 'RECENTLY_COMPLETED',
    FAVORITES: 'FAVORITES',
    NEAR_BY: 'NEAR_BY'
};

export const DEFAULT_PROFILE_IMAGE = '/images/profile/profile-pic-default.svg';
export const DEFAULT_PROFILE_IMAGE_2 = '/images/avatars/default.png';
export const DEFAULT_GROUP_IMAGE = '/modern/images/avatar-default-groups.gif';
